import { default as UserTeamManagementModal } from './UserTeamManagementModal';

export default UserTeamManagementModal;
